<div class="h-full w-full bg-white flex flex-col justify-between overflow-hidden">
    <!-- Header -->
    <div class="flex justify-between items-center p-4 h-auto">
        <!-- Logo -->
        <div class="w-30 h-auto">
            <img class="w-90 h-auto" src="images/logo/logo.svg" />
        </div>

        <button mat-icon-button mat-dialog-close (click)="close()" class="icon-size-2" *ngIf="shouldShowCloseButton()">
                <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- Instructions -->
     <div class="flex flex-col items-center justify-center w-full pt-6 sm:pt-10 mb-4 sm:mb-8">
      <h1 class="text-3xl sm:text-3xl font-extrabold leading-tight text-center">
        {{ 'otpvalidation.otpsuggestmaintitle' | transloco }}
      </h1>
      <div class="mt-0.5 text-base sm:text-base font-medium text-gray-500 text-center">
        {{ 'otpvalidation.otpsuggestsubtitle' | transloco }}<br />
        <span class="font-semibold">{{ 'register.subtitle2' | transloco }}</span>
      </div>
    </div>

    <!-- Button -->
    <button
        (click)="cambiarContrasenya()"
        class="w-full my-button py-3 rounded-full bg-teal-700 text-white font-semibold text-base hover:bg-teal-800 transition"
    >
        {{'otpvalidation.changepwdBtn' | transloco}}
    </button>

    <!-- Help -->
    <p class="text-base text-gray-500 mt-4 text-center">
        <button (click)="close()" class="text-[#006E75] hover:text-[#003E42] hover:underline underline underline-offset-2 font-medium">
            {{'otpvalidation.postpone' | transloco}}
        </button>
    </p>
</div>
